export default __webpack_public_path__ + "static/media/AMS - downloaded_Dark2.6fb2ad2a.svg";